export default {
  type: 'invoice',
  config: {
    relationships: {
      original_version: {
        type: 'invoice'
      },
      previous_version: {
        type: 'invoice'
      },
      provided_service: {
        type: 'provided_service'
      },
      submitter: {
        type: 'employee'
      },
      invoice_rejection_reason: {
        type: 'invoice_rejection_reason'
      },
      invoice_dispute_reason: {
        type: 'invoice_dispute_reason'
      },
      invoice_dispute_resolution_reason: {
        type: 'invoice_dispute_resolution_reason'
      },
      user_archives: {
        type: 'user_archive'
      }
    }
  }
};
//# sourceMappingURL=invoice.js.map